import { FC, useEffect, useState } from 'react';
import { Button, Modal, Space } from 'antd';
import SelectRuleGroupModalChildren from './ModalChildren';
import styles from './index.module.scss';
import { IotProtocolType } from '@/shared/types';
import { RuleGroupList } from '@/pages/Device/BatchBindRuleGroup/SelectRuleGroup/types';
interface SelectRuleGroupProps {
  value?: RuleGroupList[];
  onChange?: (value?: RuleGroupList[]) => void;
  rootMcid?: string;
  deviceTypeId?: number;
  iotProtocol?: IotProtocolType;
  objectModalType?: number;
}

const SelectRuleGroup: FC<SelectRuleGroupProps> = ({
  value,
  onChange,
  rootMcid,
  deviceTypeId,
  iotProtocol,
  objectModalType,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const [dataSource, setDataSource] = useState<RuleGroupList[]>();
  const [modalApi, modalContextHolder] = Modal.useModal();

  useEffect(() => {
    setDataSource(value);
  }, [value]);

  const onAdd = () => {
    if (rootMcid === undefined) {
      modalApi.warning({
        title: '请先选择所属租户',
      });
      return;
    }
    if (iotProtocol === undefined) {
      modalApi.warning({
        title: '请先选择物联层协议',
      });
      return;
    }
    if (iotProtocol === IotProtocolType.MOCKINGBIRD && deviceTypeId === undefined) {
      modalApi.warning({
        title: '请先选择适用设备类目',
      });
      return;
    }
    setVisible(true);
  };

  const onCancel = () => {
    setDataSource(value);
    setVisible(false);
  };

  const onOk = () => {
    onChange?.(dataSource);
    setVisible(false);
  };


  return (
    <>
      <Space>
        {(value ?? []).map(item => item.name).join('、')}
        <Button type="link" onClick={onAdd}>
          {value === undefined ? '点击' : '重新'}选择
        </Button>
      </Space>
      <Modal
        className={styles.modal}
        title="规则选择"
        open={visible}
        destroyOnClose
        onOk={onOk}
        onCancel={onCancel}
        width={800}
      >
        <SelectRuleGroupModalChildren
          rootMcid={rootMcid}
          iotProtocol={iotProtocol}
          deviceTypeId={deviceTypeId}
          onChange={setDataSource}
          value={dataSource}
          objectModalType={objectModalType}
        />
      </Modal>
      {modalContextHolder}
    </>
  );
};

export default SelectRuleGroup;
